module.exports = __webpack_public_path__ + "videos/banners.2141a06.webm";